module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MECHANICAL ENGINEERING-9e8ce09fb46a7c901654ca1ebc169219.png";